import React from 'react';
import PropTypes from 'prop-types';

function IconBack({ size = 24, color = `#C2C2C2`, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M7.99999 18.5H6.33333C6.24493 18.5 6.16014 18.4658 6.09763 18.4048C6.03512 18.3439 6 18.2612 6 18.175V5.825C6 5.7388 6.03512 5.65614 6.09763 5.59519C6.16014 5.53424 6.24493 5.5 6.33333 5.5H7.99999C8.08839 5.5 8.17318 5.53424 8.23569 5.59519C8.2982 5.65614 8.33332 5.7388 8.33332 5.825V18.175C8.33332 18.2612 8.2982 18.3439 8.23569 18.4048C8.17318 18.4658 8.08839 18.5 7.99999 18.5ZM17.4773 18.1486L8.73118 12.2675C8.53905 12.1384 8.53905 11.8616 8.73118 11.7325L17.4773 5.85146C17.6985 5.70261 18 5.85704 18 6.11899V17.8811C18 18.143 17.6985 18.2973 17.4773 18.1486Z" fill={color} />
    </svg>
  )
}

IconBack.propTypes = {
  size: PropTypes.number.isRequired,
  color: PropTypes.string,
  className: PropTypes.string
}

export default IconBack;
